import React, { Component, createRef } from "react";
import { Tooltip } from "react-tooltip";
import "react-tooltip/dist/react-tooltip.css";
import { Sidebar } from "primereact/sidebar";
import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import { TabView, TabPanel } from "primereact/tabview";
import { Image } from "primereact/image";
import logo from "../../Assests/RebelSkool.png";
import { InputMask } from "primereact/inputmask";
import { InputNumber } from "primereact/inputnumber";
import { RadioButton } from "primereact/radiobutton";
import { validateEmail } from "./utils";
import axios from "axios";
import { Toast } from "primereact/toast";
import { Dialog } from "primereact/dialog";
import { FcApproval, FcCancel } from "react-icons/fc";
import { connect } from "react-redux";
import TranslationFile from "../15-Translation/locale/Translation_apps.json";
import { SignUpVerifyEmail } from "./SignUpVerifyEmail";
import { setUserSessionAuthKey } from "../../Component/commonUtils";
import config from "../../Configuration/Config";
import $ from "jquery";
import "./Login.css";

import usePasswordValidator from "./usePasswordValidator";
import { CreateForgetPasswordLink } from "./CreateForgetPasswordLink";
import ForgetPassword from "./ForgetPassword";
import { Password } from "primereact/password";
import { RiArrowDownSFill } from "react-icons/ri";
import { HashLink } from "react-router-hash-link";
import { Checkbox } from "primereact/checkbox";
import { Divider } from "primereact/divider";
import { Link } from "react-scroll";

const mapStateToProps = (state) => {
  return {
    annualReportType: state.annualReportType.annualReportType.values,
    companyInformation: state.companyInformation.companyInformation.values,
    financialYear: state.financialYear.financialYear,
    incomeStatement: state.incomeStatement.incomeStatement,
    sessionDetails: state.sessionDetails.sessionDetails,
    sideBarReducer: state.sideBarReducer.sideBarReducer,
    language: state.language.language,
    activeSideBar: state.activeSideBar.activeSideBar,
    prices: state.prices.prices,
    currentPageName: state.currentPageName.currentPageName,
    login: state.login.login,
    pricesToLogin: state.pricesToLogin.pricesToLogin.values
  };
};

let renderOneTime = true;
let loggedIn = "";
let userSelectedLanguage,
  userTimeZone = "",
  statusBandFromLS = "";
let userSessionAuthKeyReturnValue = setUserSessionAuthKey();
let rebelSkoolUserLS = localStorage.getItem("rebelSkoolUser");
let rebelSkoolUserLSParse = "";

class LoginNew extends Component {
  constructor(props) {
    super(props);
    this.valueRef = React.createRef();
    this.errorRef = createRef();
    this.privatePasswordInputRef = React.createRef();
    this.accountingPasswordInputRef = React.createRef();
    this.state = {
      loginSuccess: false,
      loginSideBarVisible: false,
      activeIndex: 0,
      activeSubTabIndex: 1,
      username: "",
      email: "",
      password: "",
      confirmPassword: "",
      registrationNo: "",
      companyName: "",
      address: "",
      postalCode: "",
      city: "",
      iAcceptChecked: false,
      userNameFromResponse: "",
      userRoleFromResponse: "",
      isAccountingCompanyFromResponse: false,
      emailNotExists: false,
      emailAlreadyExists: false,
      isActiveEmailId: true,
      signUpType: "private",
      privateUserName: "",
      privateUserLastName: "",
      privateEmailId: "",
      privatePassword: "",
      privateConfirmPassword: "",
      showPasswordTooltip: false,
      passwordValidation: {
        minLength: false,
        uppercase: false,
        number: false,
        specialChar: false
      },
      isPrivateConfirmPasswordBlur: false,
      isPrivatePasswordMismatch: true,
      isPrivateEmailIdValid: true,
      iPrivateAcceptChecked: false,
      isPrivateEmailAlreadyExists: false,
      accountingCompanyRegNo: "",
      accountingCompanyName: "",
      accountingCompanyAddress: "",
      accountingCompanyPostalCode: "",
      accountingCompanyCity: "",
      accountingCompanyUserName: "",
      accountingCompanyUserLastName: "",
      accountingCompanyEmailId: "",
      accountingCompanyPassword: "",
      accountingCompanyConfirmPassword: "",
      /*showPasswordTooltip: false,
      passwordValidation: {
        minLength: false,
        uppercase: false,
        number: false,
        specialChar: false
      }, */
      isAccountingCompanyRegNoAlreadyExists: false,
      isAccountingCompanyPasswordMismatch: true,
      isAccountingCompanyConfirmPasswordBlur: false,
      isAccountingCompanyEmailIdValid: true,
      iAccountingCompanyAcceptChecked: false,
      isAccountingCompanyEmailAlreadyExists: false,
      forgotPasswordDialogVisible: false,
      resetEmail: "",
      emailExistsAlready: false,
      sessionUUID: "",
      emailDoesNotExists: false,
      redirectToForgetPassword: false,
      showEmailVerificationMessage: false,
      showEmailVerificationNeed: false,
      resetPasswordBtnLoading: false,
      isMaskedLogin: true,
      isMaskedSignUp: true,
      isMaskedSignUp1: true,
      signupCheckEmailDialogBox: false,
      testValue: "",
      jsonIntegrationCheckbox: false
    };
  }
  componentDidUpdate(prevProps, prevState) {
    if (
      this.state.isAccountingCompanyRegNoAlreadyExists &&
      !prevState.isAccountingCompanyRegNoAlreadyExists
    ) {
      setTimeout(() => {
        this.errorRef.current?.scrollIntoView({
          behavior: "smooth",
          block: "center"
        });
      }, 100);
    }
  }
  componentWillMount() {
    userTimeZone = localStorage.getItem("userTimeZone");
    statusBandFromLS =
      localStorage.getItem("StatusBand") &&
      JSON.parse(localStorage.getItem("StatusBand"));
    let openLoginSidebar = localStorage.getItem("openLoginSidebar");
    this.setState({
      loginSideBarVisible: JSON.parse(openLoginSidebar)
    });
    localStorage.removeItem("openLoginSidebar");
    userSessionAuthKeyReturnValue = setUserSessionAuthKey();
    userSelectedLanguage = localStorage.getItem("selectedLanguage");
    const { sessionDetails, pricesToLogin } = this.props;

    if (rebelSkoolUserLS != "undefined") {
      rebelSkoolUserLSParse = JSON.parse(rebelSkoolUserLS);
    }

    if (
      rebelSkoolUserLSParse != null &&
      rebelSkoolUserLSParse.userName != "" &&
      rebelSkoolUserLSParse.userName != undefined
    ) {
      this.setState({
        loginSuccess: true,
        usernameFromResponse: rebelSkoolUserLSParse.userName,
        userRoleFromResponse: rebelSkoolUserLSParse.userRole,
        isAccountingCompanyFromResponse:
          rebelSkoolUserLSParse.isAccountingCompany
      });
    }
  }

  header() {
    return <div className="font-bold mb-3">Pick a password</div>;
  }
  footer() {
    return (
      <>
        <Divider />
        <p className="mt-2">Suggestions</p>
        <ul className="pl-2 ml-2 mt-0 line-height-3">
          <li>Minimum 6 characters</li>
          <li>At least one lowercase</li>
          <li>At least one uppercase</li>
          <li>At least one numeric</li>
        </ul>
      </>
    );
  }

  componentDidMount() {
    const { sessionDetails } = this.props;
    setTimeout(() => {
      if (
        sessionDetails["values"] != undefined &&
        sessionDetails["values"]["uuid"].length > 0
      ) {
        this.setState({
          sessionUUID: sessionDetails.values.uuid
        });
      }
    }, 1000);
  }

  loginSideBarOnClick() {
    this.setState({
      loginSideBarVisible: false
    });
    setTimeout(() => {}, 50);
    this.setState({
      email: "",
      password: "",
      confirmPassword: "",
      emailNotExists: false,
      isActiveEmailId: true,
      privateUserName: "",
      privateUserLastName: "",
      privateEmailId: "",
      privatePassword: "",
      privateConfirmPassword: "",
      showPasswordTooltip: false,
      isPrivateConfirmPasswordBlur: false,
      isPrivatePasswordMismatch: true,
      isPrivateEmailIdValid: true,
      accountingCompanyName: "",
      accountingCompanyAddress: "",
      accountingCompanyPostalCode: "",
      accountingCompanyCity: "",
      accountingCompanyUserName: "",
      accountingCompanyUserLastName: "",
      accountingCompanyEmailId: "",
      accountingCompanyPassword: "",
      accountingCompanyConfirmPassword: "",
      isAccountingCompanyRegNoAlreadyExists: false,
      isAccountingCompanyEmailIdValid: true,
      iAcceptChecked: false,
      iPrivateAcceptChecked: false,
      iAccountingCompanyAcceptChecked: false,
      isPrivateEmailAlreadyExists: false,
      accountingCompanyRegNo: ""
    });
  }

  tabOnChange(e, tabName) {
    if (tabName == "parentTab") {
      this.setState({
        activeIndex: e.index
      });
    } else {
      this.setState({
        activeSubTabIndex: e.index
      });
    }

    this.setState({
      email: "",
      password: "",
      confirmPassword: "",
      emailNotExists: false,
      isActiveEmailId: true,
      privateUserName: "",
      privateUserLastName: "",
      privateEmailId: "",
      privatePassword: "",
      privateConfirmPassword: "",
      showPasswordTooltip: false,
      isPrivateConfirmPasswordBlur: false,
      isPrivatePasswordMismatch: true,
      isPrivateEmailIdValid: true,
      accountingCompanyRegNo: "",
      accountingCompanyName: "",
      accountingCompanyAddress: "",
      accountingCompanyPostalCode: "",
      accountingCompanyCity: "",
      accountingCompanyUserName: "",
      accountingCompanyUserLastName: "",
      accountingCompanyEmailId: "",
      accountingCompanyPassword: "",
      accountingCompanyConfirmPassword: "",
      isAccountingCompanyRegNoAlreadyExists: false,
      isAccountingCompanyEmailIdValid: true,
      iAcceptChecked: false,
      iPrivateAcceptChecked: false,
      iAccountingCompanyAcceptChecked: false
    });
  }

  emailOnChange(e) {
    this.setState({
      email: e
    });
  }

  emailOnBlur() {
    const { email } = this.state;
    if (email != "") {
      let userLoginDetails = {
        emailID: email
      };
      axios
        .post("/user/checkIfEmailExists", userLoginDetails)
        .then((response) => {
          if (response.data) {
            this.setState({
              emailNotExists: false
            });
            const encodedEmail = encodeURIComponent(email);

            axios
              .get("/user/getByEmail?emailId=" + encodedEmail)
              .then((userDetailsByEmailResponse) => {
                let userDetailsByEmail = userDetailsByEmailResponse.data;
                if (!userDetailsByEmail.isEmailVerified) {
                  this.setState({ showEmailVerificationNeed: true });
                } else {
                  this.setState({ showEmailVerificationNeed: false });
                }
              });
            const encodedEmail1 = encodeURIComponent(userLoginDetails.emailID);
            axios
              .get("/user/getUserActiveStatus?emailId=" + encodedEmail1)
              .then((responseEmailIdStatus) => {
                if (responseEmailIdStatus.data) {
                  this.setState({
                    isActiveEmailId: true
                  });
                } else {
                  this.setState({
                    isActiveEmailId: false
                  });
                }
              });
          } else {
            this.setState({
              emailNotExists: true
            });
          }
        });
    } else {
      this.setState({
        emailNotExists: false
      });
    }
  }

  privateEmailOnChange(e) {
    this.setState({
      privateEmailId: e
    });
    this.resetAccountingCompanyRelatedStates();
  }

  privateEmailOnBlur() {
    const { privateEmailId } = this.state;
    if (privateEmailId != "") {
      let isValidEmailAddress = validateEmail(privateEmailId);
      if (isValidEmailAddress) {
        this.setState({
          isPrivateEmailIdValid: true
        });

        let userLoginDetails = {
          emailID: privateEmailId
        };
        axios
          .post("/user/checkIfEmailExists", userLoginDetails)
          .then((response) => {
            if (response.data) {
              this.setState({
                isPrivateEmailAlreadyExists: true
              });
            } else {
              this.setState({
                isPrivateEmailAlreadyExists: false
              });
            }
          });
      } else {
        this.setState({
          isPrivateEmailIdValid: false
        });
      }
    } else {
      this.setState({
        isPrivateEmailAlreadyExists: false
      });
    }
  }

  accountingCompanyEmailIdOnBlur() {
    const { accountingCompanyEmailId } = this.state;
    if (accountingCompanyEmailId != "") {
      let isValidEmailAddress = validateEmail(accountingCompanyEmailId);

      if (isValidEmailAddress) {
        this.setState({
          isAccountingCompanyEmailIdValid: true
        });

        let userLoginDetails = {
          emailID: accountingCompanyEmailId
        };
        axios
          .post("/user/checkIfEmailExists", userLoginDetails)
          .then((response) => {
            if (response.data) {
              this.setState({
                isAccountingCompanyEmailAlreadyExists: true
              });
            } else {
              this.setState({
                isAccountingCompanyEmailAlreadyExists: false
              });
            }
          });
      } else {
        this.setState({
          isAccountingCompanyEmailIdValid: false
        });
      }
    } else {
      this.setState({
        isAccountingCompanyEmailAlreadyExists: false
      });
    }
  }

  passwordOnChange(e) {
    this.setState({
      password: e
    });
  }

  passwordOnBlur() {
    const { password } = this.state;
    if (password != "") {
    }
  }

  toggleMask = (field, number) => {
    if (field == "login") {
      this.setState((prevState) => ({
        isMaskedLogin: !prevState.isMaskedLogin
      }));
    } else if (field == "signUp") {
      if (number == 1) {
        this.setState((prevState) => ({
          isMaskedSignUp: !prevState.isMaskedSignUp
        }));
      } else {
        this.setState((prevState) => ({
          isMaskedSignUp1: !prevState.isMaskedSignUp1
        }));
      }
    }
  };

  validatePassword(password) {
    const validation = {
      minLength: password.length >= 6,
      uppercase: /[A-Z]/.test(password),
      number: /[0-9]/.test(password),
      specialChar: /[!@#$%^&*(),.?":{}|<>]/.test(password)
    };

    this.setState({
      passwordValidation: validation
    });
  }

  privatePasswordOnChange(e) {
    this.setState({
      privatePassword: e
    });

    this.validatePassword(e);

    const isValid =
      e.length >= 6 &&
      /[A-Z]/.test(e) &&
      /[0-9]/.test(e) &&
      /[!@#$%^&*(),.?":{}|<>]/.test(e);

    this.setState({
      showPasswordTooltip: e.length > 0 && !isValid
    });

    this.resetAccountingCompanyRelatedStates();
  }

  privatePasswordOnBlur() {
    const { privateConfirmPassword, privatePassword } = this.state;
    if (privateConfirmPassword != "") {
      if (privatePassword == privateConfirmPassword) {
        this.setState({
          isPrivatePasswordMismatch: false
        });
      } else {
        this.setState({
          isPrivatePasswordMismatch: true
        });
      }
    }
  }

  handlePrivateSignUpClick = () => {
    const {
      privatePassword,
      privateConfirmPassword,
      privateUserName,
      privateUserLastName,
      privateEmailId,
      isPrivateEmailIdValid,
      isPrivateEmailAlreadyExists,
      passwordValidation
    } = this.state;

    const isPasswordValid =
      passwordValidation.minLength &&
      passwordValidation.uppercase &&
      passwordValidation.number &&
      passwordValidation.specialChar;

    if (!isPasswordValid || privatePassword === "") {
      this.setState({ showPasswordTooltip: true });
      if (this.privatePasswordInputRef.current) {
        this.privatePasswordInputRef.current.focus();
      }
      return;
    }

    // Passwords don't match
    if (
      privateConfirmPassword === "" ||
      privatePassword !== privateConfirmPassword
    ) {
      this.setState({
        isPrivatePasswordMismatch: true,
        isPrivateConfirmPasswordBlur: true
      });
      return;
    }

    if (
      isPrivateEmailAlreadyExists ||
      !isPrivateEmailIdValid ||
      privateUserName.trim() === "" ||
      privateUserLastName.trim() === "" ||
      privateEmailId.trim() === ""
    ) {
      return;
    }

    this.signedUpSuccessfully("private");
  };

  privateConfirmPasswordOnChange(e) {
    this.setState({
      privateConfirmPassword: e
    });

    if (e == this.state.privatePassword)
      this.setState({
        isPrivatePasswordMismatch: false
      });
    else
      this.setState({
        isPrivatePasswordMismatch: true
      });

    this.resetAccountingCompanyRelatedStates();
  }

  privateConfirmPasswordOnBlur() {
    const { privateConfirmPassword, privatePassword } = this.state;
    if (privateConfirmPassword != "") {
      this.setState({
        isPrivateConfirmPasswordBlur: true
      });
      if (privateConfirmPassword == privatePassword) {
        this.setState({
          isPrivatePasswordMismatch: false
        });
      } else {
        this.setState({
          isPrivatePasswordMismatch: true
        });
      }
    }
  }

  accountingCompanyPasswordOnBlur() {
    const { accountingCompanyConfirmPassword, accountingCompanyPassword } =
      this.state;

    if (accountingCompanyConfirmPassword != "") {
      if (accountingCompanyPassword == accountingCompanyConfirmPassword) {
        this.setState({
          isAccountingCompanyPasswordMismatch: false
        });
      } else {
        this.setState({
          isAccountingCompanyPasswordMismatch: true
        });
      }
    }
  }

  handleAccountingSignUpClick = () => {
    const {
      accountingCompanyPassword,
      accountingCompanyConfirmPassword,
      accountingCompanyRegNo,
      accountingCompanyName,
      accountingCompanyUserName,
      accountingCompanyUserLastName,
      accountingCompanyEmailId,
      accountingCompanyAddress,
      accountingCompanyPostalCode,
      accountingCompanyCity,
      isAccountingCompanyEmailIdValid,
      isAccountingCompanyEmailAlreadyExists,
      isAccountingCompanyRegNoAlreadyExists,
      passwordValidation
    } = this.state;

    const isPasswordValid =
      passwordValidation.minLength &&
      passwordValidation.uppercase &&
      passwordValidation.number &&
      passwordValidation.specialChar;

    if (!isPasswordValid || accountingCompanyPassword === "") {
      this.setState({ showPasswordTooltip: true });
      if (this.accountingPasswordInputRef.current) {
        this.accountingPasswordInputRef.current.focus();
      }
      return;
    }

    // Passwords don't match
    if (
      accountingCompanyConfirmPassword === "" ||
      accountingCompanyPassword !== accountingCompanyConfirmPassword
    ) {
      this.setState({
        isAccountingCompanyPasswordMismatch: true,
        isAccountingCompanyConfirmPasswordBlur: true
      });
      return;
    }

    if (
      isAccountingCompanyEmailAlreadyExists ||
      !isAccountingCompanyEmailIdValid ||
      isAccountingCompanyRegNoAlreadyExists ||
      accountingCompanyRegNo.trim() === "" ||
      accountingCompanyName.trim() === "" ||
      accountingCompanyUserName.trim() === "" ||
      accountingCompanyUserLastName.trim() === "" ||
      accountingCompanyEmailId.trim() === "" ||
      accountingCompanyAddress.trim() === "" ||
      accountingCompanyPostalCode.trim() === "" ||
      accountingCompanyCity.trim() === ""
    ) {
      return;
    }

    this.signedUpSuccessfully("accountingCompany");
  };

  accountingCompanyConfirmPasswordOnBlur() {
    const { accountingCompanyConfirmPassword, accountingCompanyPassword } =
      this.state;
    if (accountingCompanyConfirmPassword != "") {
      this.setState({
        isAccountingCompanyConfirmPasswordBlur: true
      });
      if (accountingCompanyConfirmPassword == accountingCompanyPassword) {
        this.setState({
          isAccountingCompanyPasswordMismatch: false
        });
      } else {
        this.setState({
          isAccountingCompanyPasswordMismatch: true
        });
      }
    }
  }

  loginButtonOnClick(email, password) {
    const { login, currentPageName } = this.props;
    let userEmailPasswordDetails = {
      emailID: email,
      password: password,
      checkHashCode: true
    };

    if (
      userEmailPasswordDetails.emailID != "" &&
      userEmailPasswordDetails.password != ""
    ) {
      axios
        .post("/user/loginAndGetUser", userEmailPasswordDetails)
        .then((response) => {
          if (
            response.data.emailID !== null &&
            response.data.userName !== null
          ) {
            const userAuthKey = response.headers["user-session-auth-key"];
            this.setState({
              loginSuccess: true,
              loginSideBarVisible: false,
              usernameFromResponse: response.data.userName,
              userRoleFromResponse: response.data.userRole,
              isAccountingCompanyFromResponse: response.data.isAccountingCompany
            });
            login.values = response.data;
            response.data["User-Session-Auth-Key"] = userAuthKey;
            localStorage.setItem(
              "rebelSkoolUser",
              JSON.stringify(response.data)
            );
            if (
              currentPageName &&
              (currentPageName.values == "Home" ||
                currentPageName.values == "home")
            ) {
              localStorage.setItem("navigateTo", "MainDashboard");
            }

            let splittedUrl = window.location.href.split("/");
            let currentReportGUIDFromUrl = splittedUrl[splittedUrl.length - 2];

            let updateCreatedByUserId = {
              createdByUserID: response.data.userID,
              reportGUID: currentReportGUIDFromUrl
            };

            // axios
            //   .post(
            //     "/annualReport/updateCreatedByUserId",
            //     updateCreatedByUserId
            //   )
            //   .then((response) => {});
            // window.location.reload(false);

            if (window.location.href.includes("/income-declaration-2/")) {
              // Income Declaration 2
              axios
                .post("/SRUHeader/updateCreatedByUserId", updateCreatedByUserId)
                .then((response) => {
                  window.location.reload(false);
                });
            } else {
              // Annual Report - Existing logic
              axios
                .post(
                  "/annualReport/updateCreatedByUserId",
                  updateCreatedByUserId
                )
                .then((response) => {
                  window.location.reload(false);
                });
            }
          } else {
            this.toast.show({
              severity: "error",
              summary: TranslationFile.errorText[userSelectedLanguage],
              detail: TranslationFile.InvalidPasswordText[userSelectedLanguage],
              life: 2000
            });
          }
        });
    }
  }

  signUpTypeRadioBtnOnClick(e, radioBtnLabel) {
    this.setState({
      signUpType: e.value,
      email: "",
      password: "",
      confirmPassword: "",
      emailNotExists: false,
      isActiveEmailId: true
    });
  }

  footerContent() {
    return (
      <div>
        <Button
          label={TranslationFile.DoneBtn[userSelectedLanguage]}
          icon="pi pi-check"
          autoFocus
        />
      </div>
    );
  }

  termsAndConditons(subTab) {
    return (
      <div className="login-terms-condition">
        <span>
          {/* * I accept the  */}
          {TranslationFile.loginAcceptText[userSelectedLanguage]}
        </span>
        <span>
          <a
            className="classcolourterm"
            href={config.corporatePage.url + "terms-of-usage"}
            target="_blank"
            rel="noreferrer"
          >
            {TranslationFile.loginTermsText[userSelectedLanguage]}
          </a>
        </span>
      </div>
    );
  }

  showError(errorMessage) {
    this.toast.show({
      severity: "error",
      summary: TranslationFile.errorText[userSelectedLanguage],
      detail: errorMessage,
      life: 2000
    });
  }

  signedUpSuccessfully(tabHeader) {
    let splittedUrl = window.location.href.split("/");
    let currentReportGUIDFromUrl = splittedUrl[splittedUrl.length - 2];
    const {
      privateUserName,
      privateUserLastName,
      privateEmailId,
      privatePassword,
      privateConfirmPassword,
      accountingCompanyRegNo,
      accountingCompanyName,
      accountingCompanyAddress,
      accountingCompanyPostalCode,
      accountingCompanyCity,
      accountingCompanyUserName,
      accountingCompanyUserLastName,
      accountingCompanyEmailId,
      accountingCompanyPassword,
      accountingCompanyConfirmPassword,
      jsonIntegrationCheckbox
    } = this.state;

    let userDetails = {
      createdByUserID: 0,
      userRole: "Admin"
    };

    let isAllFieldFilled = false,
      isAccountingCompany = false;

    if (tabHeader == "private") {
      if (
        privateUserName != "" &&
        privateUserLastName != "" &&
        privateEmailId != "" &&
        privatePassword != "" &&
        privateConfirmPassword != ""
      ) {
        userDetails.userName = privateUserName;
        userDetails.firstName = privateUserName;
        userDetails.lastName = privateUserLastName;
        userDetails.emailID = privateEmailId;
        userDetails.password = privatePassword;
        userDetails.reportGUID = currentReportGUIDFromUrl;
        isAllFieldFilled = true;
        isAccountingCompany = false;
      }
    } else {
      if (
        accountingCompanyRegNo != "" &&
        accountingCompanyName != "" &&
        accountingCompanyUserName != "" &&
        accountingCompanyUserLastName != "" &&
        accountingCompanyEmailId != "" &&
        accountingCompanyPassword != "" &&
        accountingCompanyConfirmPassword != ""
      ) {
        userDetails.userName = accountingCompanyUserName;
        userDetails.firstName = accountingCompanyUserName;
        userDetails.lastName = accountingCompanyUserLastName;
        userDetails.emailID = accountingCompanyEmailId;
        userDetails.password = accountingCompanyPassword;
        userDetails.accountingCompanyName = accountingCompanyName;
        userDetails.registrationNo = accountingCompanyRegNo;
        userDetails.address = accountingCompanyAddress;
        if (accountingCompanyPostalCode == null) {
          userDetails.postalCode = "";
        } else {
          userDetails.postalCode = accountingCompanyPostalCode;
        }
        userDetails.city = accountingCompanyCity;
        isAllFieldFilled = true;
        isAccountingCompany = true;
        userDetails.isAdminUser = true;
        userDetails.reportGUID = currentReportGUIDFromUrl;
        userDetails.jsonIntegration = jsonIntegrationCheckbox;
      }
    }

    if (isAllFieldFilled) {
      if (isAccountingCompany) {
        axios
          .post("/accountingCompany/initializeWithUserAndAccess", userDetails)
          .then((response) => {
            if (response.data) {
              SignUpVerifyEmail(userDetails.emailID, userDetails.password);
              this.setState({
                showEmailVerificationMessage: true,
                loginSideBarVisible: false,
                signupCheckEmailDialogBox: true
              });
              setTimeout(() => {
                this.setState({
                  accountingCompanyRegNo: "",
                  accountingCompanyName: "",
                  accountingCompanyAddress: "",
                  accountingCompanyPostalCode: "",
                  accountingCompanyCity: "",
                  accountingCompanyUserName: "",
                  accountingCompanyUserLastName: "",
                  accountingCompanyEmailId: "",
                  accountingCompanyPassword: "",
                  accountingCompanyConfirmPassword: ""
                });
              }, 1000);
            }
          });
      } else {
        if (userDetails.reportGUID.toUpperCase() == "ANNUALREPORT") {
          userDetails.reportGUID = null;
        }
        axios.post("/user/insert", userDetails).then((response) => {
          if (response.data) {
            this.setState({
              loginSideBarVisible: false
            });
            SignUpVerifyEmail(userDetails.emailID, userDetails.password);
            this.setState({
              showEmailVerificationMessage: true,
              signupCheckEmailDialogBox: true
            });
          }
          this.loginSideBarOnClick();
        });
      }

      this.setState({
        emailID: userDetails.emailID,
        password: userDetails.password
      });
    }
  }

  accountingCompanyRegNoOnBlur() {
    const { accountingCompanyRegNo } = this.state;
    axios
      .get(
        "/accountingCompany/checkRegistrationNoExists?registrationNo=" +
          accountingCompanyRegNo
      )
      .then((response) => {
        if (response.data) {
          this.setState({
            isAccountingCompanyRegNoAlreadyExists: true
          });
        } else {
          this.setState({
            isAccountingCompanyRegNoAlreadyExists: false
          });
        }
      });
  }

  privateUserNameOnChange(e, name) {
    if (name == "name") {
      this.setState({
        privateUserName: e.target.value
      });
    } else {
      this.setState({
        privateUserLastName: e.target.value
      });
    }

    this.resetAccountingCompanyRelatedStates();
  }

  resetAccountingCompanyRelatedStates() {
    this.setState({
      accountingCompanyRegNo: "",
      accountingCompanyName: "",
      accountingCompanyAddress: "",
      accountingCompanyPostalCode: "",
      accountingCompanyCity: "",
      accountingCompanyUserName: "",
      accountingCompanyUserLastName: "",
      accountingCompanyEmailId: "",
      accountingCompanyPassword: "",
      accountingCompanyConfirmPassword: "",
      isAccountingCompanyRegNoAlreadyExists: false,
      isAccountingCompanyPasswordMismatch: true,
      isAccountingCompanyConfirmPasswordBlur: false,
      isAccountingCompanyEmailIdValid: true,
      iAccountingCompanyAcceptChecked: false,
      isAccountingCompanyEmailAlreadyExists: false
    });
  }

  resetPrivateRelatedStates() {
    this.setState({
      privateUserName: "",
      privateUserLastName: "",
      privateEmailId: "",
      privatePassword: "",
      privateConfirmPassword: "",
      showPasswordTooltip: false,
      isPrivateConfirmPasswordBlur: false,
      isPrivatePasswordMismatch: true,
      isPrivateEmailIdValid: true,
      iPrivateAcceptChecked: false,
      isPrivateEmailAlreadyExists: false
    });
  }

  accountingCompanyRegNoOnChange(e) {
    this.setState({
      accountingCompanyRegNo: e.target.value
    });
    this.resetPrivateRelatedStates();
  }

  accountingCompanyNameOnChange(e) {
    this.setState({
      accountingCompanyName: e.target.value
    });
    this.resetPrivateRelatedStates();
  }

  accountingCompanyAddressOnChange(e) {
    this.setState({
      accountingCompanyAddress: e.target.value
    });
    this.resetPrivateRelatedStates();
  }

  accountingCompanyPostalCodeOnChange(e) {
    this.setState({
      accountingCompanyPostalCode: e.target.value
    });
    this.resetPrivateRelatedStates();
  }

  accountingCompanyCityOnChange(e) {
    this.setState({
      accountingCompanyCity: e.target.value
    });
    this.resetPrivateRelatedStates();
  }

  accountingCompanyUserNameOnChange(e, name) {
    if (name == "name") {
      this.setState({
        accountingCompanyUserName: e.target.value
      });
    } else {
      this.setState({
        accountingCompanyUserLastName: e.target.value
      });
    }

    this.resetPrivateRelatedStates();
  }

  accountingCompanyEmailIdOnChange(e) {
    this.setState({
      accountingCompanyEmailId: e.target.value
    });
    this.resetPrivateRelatedStates();
  }

  accountingCompanyPasswordOnChange(e) {
    this.setState({
      accountingCompanyPassword: e
    });

    this.validatePassword(e);

    const isValid =
      e.length >= 6 &&
      /[A-Z]/.test(e) &&
      /[0-9]/.test(e) &&
      /[!@#$%^&*(),.?":{}|<>]/.test(e);

    this.setState({
      showPasswordTooltip: e.length > 0 && !isValid
    });
  }

  accountingCompanyConfirmPasswordOnChange(e) {
    this.setState({
      accountingCompanyConfirmPassword: e
    });

    if (e == this.state.accountingCompanyPassword)
      this.setState({
        isAccountingCompanyPasswordMismatch: false
      });
    else
      this.setState({
        isAccountingCompanyPasswordMismatch: true
      });

    this.resetPrivateRelatedStates();
  }

  signOut(e) {
    const { currentPageName } = this.props;
    e.preventDefault();
    localStorage.setItem("rebelSkoolUser", null);
    window.location.assign("/#/annualreport");
    let { login } = this.props;
    login.values = undefined;
    if (currentPageName.values == "Home") window.location.reload(false);
  }

  resetEmailOnBlur() {
    const { resetEmail } = this.state;
    if (resetEmail != "") {
      let userLoginDetails = {
        emailID: resetEmail
      };
      axios
        .post("/user/checkIfEmailExists", userLoginDetails)
        .then((response) => {
          if (response.data) {
            this.setState({ emailExistsAlready: true });
          }
        });
    }
  }

  sendPasswordResetLink(event) {
    this.setState({ resetPasswordBtnLoading: true });
    const { email, resetEmail } = this.state;
    let resetEmailValue = "";
    if (email !== "") {
      resetEmailValue = email;
    } else {
      resetEmailValue = resetEmail;
    }

    if (resetEmailValue != "") {
      let userLoginDetails = {
        emailID: resetEmailValue
      };
      event.preventDefault();

      axios
        .post("/user/checkIfEmailExists", userLoginDetails)
        .then((response) => {
          if (response.data) {
            const encodedEmail = encodeURIComponent(resetEmailValue);
            axios
              .get(
                "/user/getByEmail?emailId=" + encodedEmail,
                userSessionAuthKeyReturnValue
              )
              .then((response) => {
                let userResponseDate = response.data;
                if (userResponseDate.userID > 0) {
                  let forgetLinkEmailObject = {
                    recipient: userResponseDate.emailID,
                    contactNumber: "",
                    emailType: "forgotPassword",
                    userGUID: userResponseDate.userGUID,
                    status: "New",
                    noOfAttempts: 0,
                    userName: userResponseDate.userName,
                    firstName: userResponseDate.firstName,
                    lastName: userResponseDate.lastName
                  };

                  const url =
                    "/emailQueueController/insertEmailQueueAndSendMail";
                  const formData = new FormData();
                  const objString = JSON.stringify(forgetLinkEmailObject);

                  formData.append("request", objString);
                  const config = {
                    headers: {
                      timeZone: userTimeZone,
                      language: userSelectedLanguage
                    }
                  };
                  axios
                    .post(url, formData, config)
                    .then((response) => {
                      if (response.data) {
                        this.setState({
                          resetPasswordBtnLoading: false,
                          forgotPasswordDialogVisible: false
                        });
                        this.toast.show({
                          severity: "success",
                          summary:
                            TranslationFile.SuccessText[userSelectedLanguage],
                          detail:
                            TranslationFile.EmailResetPassword[
                              userSelectedLanguage
                            ],
                          life: 3000
                        });
                      }
                    })
                    .catch(() => {
                      this.setState({
                        resetPasswordBtnLoading: false
                      });
                      this.toast.show({
                        severity: "error",
                        summary: "Error",
                        detail:
                          "Failed to send password reset link. Please try again later.",
                        life: 3000
                      });
                    });
                }
              });
          } else {
            this.setState({
              emailDoesNotExists: true,
              resetPasswordBtnLoading: false
            });
          }
        })
        .catch(() => {
          this.setState({ resetPasswordBtnLoading: false });
          this.toast.show({
            severity: "error",
            summary: "Error",
            detail: "Something went wrong. Please try again later.",
            life: 3000
          });
        });
    }
  }

  resetEmailOnChange(e) {
    this.setState({ resetEmail: e.target.value });
  }

  headerLoginButtonOnClick() {
    this.setState({ loginSideBarVisible: true });
    $(".corp-body").removeClass("open-menu");
    $(".hamburger-menu .bar").removeClass("animate");
  }

  resendVerificationEmail(privateEmailId, privatePassword) {
    SignUpVerifyEmail(privateEmailId, privatePassword);
    this.toast.show({
      severity: "success",
      summary: "success",
      detail: "Email Sent ",
      life: 2000
    });
  }

  render() {
    const {
      isMaskedSignUp,
      isMaskedSignUp1,
      loginSuccess,
      loginSideBarVisible,
      activeIndex,
      signUpType,
      email,
      password,
      emailNotExists,
      isActiveEmailId,
      privateUserName,
      privateUserLastName,
      privateEmailId,
      privatePassword,
      privateConfirmPassword,
      isPrivatePasswordMismatch,
      isPrivateConfirmPasswordBlur,
      isPrivateEmailIdValid,
      isPrivateEmailAlreadyExists,
      accountingCompanyRegNo,
      accountingCompanyName,
      accountingCompanyAddress,
      accountingCompanyPostalCode,
      accountingCompanyCity,
      accountingCompanyUserName,
      accountingCompanyUserLastName,
      accountingCompanyEmailId,
      accountingCompanyPassword,
      accountingCompanyConfirmPassword,
      isAccountingCompanyRegNoAlreadyExists,
      isAccountingCompanyPasswordMismatch,
      isAccountingCompanyConfirmPasswordBlur,
      isAccountingCompanyEmailIdValid,
      isAccountingCompanyEmailAlreadyExists,
      forgotPasswordDialogVisible,
      showEmailVerificationNeed,
      resetPasswordBtnLoading,
      signupCheckEmailDialogBox,
      passwordValidation,
      jsonIntegrationCheckbox
    } = this.state;
    const { resetEmail, emailDoesNotExists } = this.state;

    const isPasswordValid =
      passwordValidation.minLength &&
      passwordValidation.uppercase &&
      passwordValidation.number &&
      passwordValidation.specialChar;

    if (userSelectedLanguage == null) {
      userSelectedLanguage = "sw";
    }

    return (
      <div className="login-btn-user">
        <Toast
          ref={(el) => (this.toast = el)}
          className="login_toast_success"
        />

        {!loginSuccess && (
          <div>
            <Button
              value="Login"
              className="user-btn"
              onClick={() => this.headerLoginButtonOnClick()}
            >
              {TranslationFile.loginText[userSelectedLanguage]}
            </Button>
          </div>
        )}

        {/* SIDE BAR */}
        <Sidebar
          visible={loginSideBarVisible || this.props.pricesToLogin}
          onHide={() => this.loginSideBarOnClick()}
          position="right"
          className="user-sidebar"
          style={{
            marginTop:
              statusBandFromLS && statusBandFromLS["activate"]
                ? "228px"
                : "150px"
          }}
          blockScroll={true}
        >
          <div className="loginRebelSkoolLogo">
            <Image
              src={logo}
              alt="Image"
              width="150"
              height="50"
              className="login-sidebar-logo"
            />
          </div>

          <br></br>

          <TabView
            activeIndex={activeIndex}
            onTabChange={(e) => this.tabOnChange(e, "parentTab")}
            className="flex flex-wrap gap-2 mb-3"
          >
            {/* SIGN-IN TAB */}
            <TabPanel
              header={TranslationFile.loginText[userSelectedLanguage]}
              className="login-Login-Tab"
              headerClassName="head-one"
            >
              <div className="m-0">
                <br></br>
                <InputText
                  value={email}
                  onChange={(e) => {
                    this.emailOnChange(e.target.value);
                  }}
                  onBlur={() => this.emailOnBlur()}
                  placeholder={
                    TranslationFile.loginEmailText[userSelectedLanguage]
                  }
                  className="inputtext"
                  autocomplete="new-password"
                />
                <br></br>
                <br></br>
                <div className="p-inputgroup">
                  <input
                    type={isMaskedSignUp ? "password" : "text"}
                    value={password}
                    onChange={(e) => {
                      this.passwordOnChange(e.target.value);
                    }}
                    onBlur={() => this.passwordOnBlur()}
                    placeholder={
                      TranslationFile.IncomestateYearPassword[
                        userSelectedLanguage
                      ]
                    }
                    className="p-inputtext p-component"
                    autocomplete="new-password"
                  />

                  <span
                    className="p-inputgroup-addon"
                    onClick={() => this.toggleMask("signUp", 1)}
                    style={{ cursor: "pointer" }}
                  >
                    <i
                      className={
                        isMaskedSignUp ? "pi pi-eye-slash" : "pi pi-eye"
                      }
                      style={{ fontSize: "1.2rem" }}
                    ></i>
                  </span>
                </div>

                <br></br>
                {!emailNotExists && isActiveEmailId && (
                  <center>
                    <Button
                      label={TranslationFile.loginText1[userSelectedLanguage]}
                      className="login-btn"
                      id="login_corp-btn"
                      onClick={() => {
                        this.loginButtonOnClick(email, password);
                      }}
                      disabled={this.state.showEmailVerificationNeed}
                    />
                    <br></br>
                    <br></br>
                    <Button
                      label={
                        TranslationFile.loginForgotPass[userSelectedLanguage]
                      }
                      className="login-btn"
                      id="login_forgotPass"
                      style={{ background: "white", color: "#2196F3" }}
                      onClick={() => {
                        this.setState({
                          forgotPasswordDialogVisible: true,
                          emailDoesNotExists: false,
                          resetEmail: ""
                        });
                      }}
                      outlined
                    />

                    <Button
                      label={
                        TranslationFile.loginDontHaveAccountText[
                          userSelectedLanguage
                        ]
                      }
                      style={{
                        background: "white",
                        color: "#2196F3",
                        marginTop: "5px"
                      }}
                      onClick={() => {
                        this.setState({ activeIndex: 1 });
                      }}
                    ></Button>
                  </center>
                )}

                {emailNotExists && (
                  <div className="success-msg">
                    <FcCancel className="sign-icon" />
                    <br></br>
                    {TranslationFile.loginEmailDoesnt[userSelectedLanguage]}
                    <br></br>
                    <br></br>
                    <center>
                      <Button
                        label={
                          TranslationFile.loginTrySignUp[userSelectedLanguage]
                        }
                        className="forgot-btn"
                        onClick={(e) => {
                          this.setState({
                            activeIndex: 1,
                            email: "",
                            password: "",
                            confirmPassword: "",
                            emailNotExists: false,
                            isActiveEmailId: true
                          });
                        }}
                      />
                    </center>
                  </div>
                )}

                {!isActiveEmailId && (
                  <div className="success-msg">
                    <FcCancel className="sign-icon" />
                    <br></br>
                    {TranslationFile.loginInactiveEmail[userSelectedLanguage]}
                    <br></br>
                    <br></br>
                  </div>
                )}

                {showEmailVerificationNeed && isActiveEmailId && (
                  <div className="after-sign-up-verification">
                    <p style={{ color: "Red" }}>
                      {
                        TranslationFile.EmailNotVerifiedText[
                          userSelectedLanguage
                        ]
                      }
                    </p>
                    {TranslationFile.ResendVerifyText[userSelectedLanguage]}
                    <Button
                      label={
                        TranslationFile.resendMailText[userSelectedLanguage]
                      }
                      className="login-btn"
                      style={{
                        background: "white",
                        color: "#2196F3",
                        marginTop: "1%"
                      }}
                      outlined
                      onClick={() =>
                        this.resendVerificationEmail(email, password)
                      }
                    />
                  </div>
                )}
              </div>
            </TabPanel>

            {/* SIGN-UP TAB */}
            <TabPanel
              header={TranslationFile.loginSignUpText[userSelectedLanguage]}
              className="login-SignUp-Tab"
              headerClassName="head-one"
            >
              <div className="signUpSubTabRadioBtnDiv">
                <div>
                  <RadioButton
                    inputId="private"
                    name="private"
                    value="private"
                    onChange={(e) =>
                      this.signUpTypeRadioBtnOnClick(e, "private")
                    }
                    checked={signUpType === "private"}
                  />
                  <label htmlFor="private" className="subTabRadioBtnLbl">
                    {TranslationFile.loginPrivateText[userSelectedLanguage]}
                  </label>
                </div>
                <div>
                  <RadioButton
                    inputId="Accounting Company"
                    name="pizza"
                    value="Accounting Company"
                    onChange={(e) =>
                      this.signUpTypeRadioBtnOnClick(e, "Accounting Company")
                    }
                    checked={signUpType === "Accounting Company"}
                  />
                  <label
                    htmlFor="Accounting Company"
                    className="subTabRadioBtnLbl"
                  >
                    {TranslationFile.loginAcompanyText[userSelectedLanguage]}
                  </label>
                </div>
              </div>

              {signUpType == "private" ? (
                <div>
                  <p className="loginSignUpMandatoryStar">*</p>
                  <InputText
                    value={privateUserName}
                    onChange={(e) => this.privateUserNameOnChange(e, "name")}
                    placeholder={
                      TranslationFile.LoginFirstName[userSelectedLanguage]
                    }
                    className="inputtext"
                    name="rblPrivateUserFirstName"
                    autocomplete="new-password"
                  />
                  <br></br>
                  <p className="loginSignUpMandatoryStar">*</p>
                  <InputText
                    value={privateUserLastName}
                    onChange={(e) =>
                      this.privateUserNameOnChange(e, "lastName")
                    }
                    placeholder={
                      TranslationFile.LoginLastName[userSelectedLanguage]
                    }
                    className="inputtext"
                    name="rblPrivateUserLastName"
                    autocomplete="new-password"
                  />
                  <br></br>
                  <p className="loginSignUpMandatoryStar">*</p>
                  <InputText
                    value={privateEmailId}
                    onChange={(e) => {
                      this.privateEmailOnChange(e.target.value);
                    }}
                    onBlur={() => this.privateEmailOnBlur()}
                    placeholder={
                      TranslationFile.loginEmailText[userSelectedLanguage]
                    }
                    className="inputtext"
                    name="rblEmailId"
                    autocomplete="new-password"
                  />

                  {!isPrivateEmailIdValid ? (
                    <div className="error">
                      {
                        TranslationFile.loginValidEmailText[
                          userSelectedLanguage
                        ]
                      }
                    </div>
                  ) : (
                    <div></div>
                  )}

                  <p className="loginSignUpMandatoryStar">*</p>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      width: "100%"
                    }}
                  >
                    {console.log(passwordValidation, "!!!")}
                    <div className="p-inputgroup" style={{ cursor: "pointer" }}>
                      <input
                        id="privateSignupPassword"
                        ref={this.privatePasswordInputRef}
                        type={isMaskedSignUp ? "password" : "text"}
                        value={privatePassword}
                        onChange={(e) => {
                          this.privatePasswordOnChange(e.target.value);
                        }}
                        onFocus={() => {
                          const password = this.state.privatePassword;

                          const validation = {
                            minLength: password.length >= 6,
                            uppercase: /[A-Z]/.test(password),
                            number: /[0-9]/.test(password),
                            specialChar:
                              /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/.test(
                                password
                              )
                          };

                          this.setState({
                            passwordValidation: validation,
                            showPasswordTooltip: !(
                              validation.minLength &&
                              validation.uppercase &&
                              validation.number &&
                              validation.specialChar
                            )
                          });
                        }}
                        onBlur={() => {
                          this.privatePasswordOnBlur();
                          this.setState({
                            showPasswordTooltip: false
                          });
                        }}
                        placeholder={
                          TranslationFile.IncomestateYearPassword[
                            userSelectedLanguage
                          ]
                        }
                        className="p-inputtext p-component"
                        autocomplete="new-password"
                      />

                      <span
                        className="p-inputgroup-addon"
                        onClick={() => this.toggleMask("signUp", 1)}
                        style={{ cursor: "pointer" }}
                      >
                        <i
                          className={
                            isMaskedSignUp ? "pi pi-eye-slash" : "pi pi-eye"
                          }
                          style={{ fontSize: "1.2rem" }}
                        ></i>
                      </span>
                    </div>
                  </div>

                  <Tooltip
                    anchorSelect="#privateSignupPassword"
                    isOpen={this.state.showPasswordTooltip}
                    place="left"
                    positionStrategy="fixed"
                    offset={10}
                    openEvents={{}}
                    closeEvents={{}}
                    globalCloseEvents={{}}
                    clickable
                    className="password-tooltip"
                    style={{
                      zIndex: 9999,
                      backgroundColor: "#ffb3ff",
                      color: "#ff0000",
                      borderRadius: "8px",
                      padding: "10px"
                    }}
                  >
                    <>
                      <b className="passwordReqTooltipHeader">
                        {
                          TranslationFile.passwordRequirements[
                            userSelectedLanguage
                          ]
                        }
                      </b>
                    </>
                    <hr className="passwordReqTooltipHeaderHrTag"></hr>
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        gap: "5px",
                        fontWeight: "500"
                      }}
                    >
                      <div
                        style={{
                          color: passwordValidation.minLength ? "green" : "red"
                        }}
                      >
                        {passwordValidation.minLength ? "✓" : "✗"}{" "}
                        {
                          TranslationFile.minimum6characters[
                            userSelectedLanguage
                          ]
                        }
                      </div>

                      <div
                        style={{
                          color: passwordValidation.uppercase ? "green" : "red"
                        }}
                      >
                        {passwordValidation.uppercase ? "✓" : "✗"}{" "}
                        {
                          TranslationFile.atleast1uppercaseletter[
                            userSelectedLanguage
                          ]
                        }
                      </div>

                      <div
                        style={{
                          color: passwordValidation.number ? "green" : "red"
                        }}
                      >
                        {passwordValidation.number ? "✓" : "✗"}{" "}
                        {TranslationFile.atleast1number[userSelectedLanguage]}
                      </div>

                      <div
                        style={{
                          color: passwordValidation.specialChar
                            ? "green"
                            : "red"
                        }}
                      >
                        {passwordValidation.specialChar ? "✓" : "✗"}{" "}
                        {
                          TranslationFile.atleast1specialcharacter[
                            userSelectedLanguage
                          ]
                        }
                      </div>
                    </div>
                  </Tooltip>

                  <p className="loginSignUpMandatoryStar">*</p>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      width: "100%"
                    }}
                  >
                    <div className="p-inputgroup">
                      <input
                        type={isMaskedSignUp1 ? "password" : "text"}
                        value={privateConfirmPassword}
                        onChange={(e) => {
                          this.privateConfirmPasswordOnChange(e.target.value);
                        }}
                        onBlur={() => this.privateConfirmPasswordOnBlur()}
                        placeholder={
                          TranslationFile.IncomestateYearConPassword[
                            userSelectedLanguage
                          ]
                        }
                        className="p-inputtext p-component"
                        autocomplete="new-password"
                        onKeyDown={(e) => {
                          if (e.key === "Enter") {
                            this.signedUpSuccessfully("private");
                          }
                        }}
                      />

                      <span
                        className="p-inputgroup-addon"
                        onClick={() => this.toggleMask("signUp", 2)}
                        style={{ cursor: "pointer" }}
                      >
                        <i
                          className={
                            isMaskedSignUp1 ? "pi pi-eye-slash" : "pi pi-eye"
                          }
                          style={{ fontSize: "1.2rem" }}
                        ></i>
                      </span>
                    </div>
                  </div>

                  {isPrivatePasswordMismatch &&
                    privatePassword != "" &&
                    privateConfirmPassword != "" &&
                    isPrivateConfirmPasswordBlur && (
                      <div className="error">
                        {
                          TranslationFile.PasswordMustMatchText[
                            userSelectedLanguage
                          ]
                        }
                      </div>
                    )}

                  <Button
                    label={
                      TranslationFile.loginSignUpText[userSelectedLanguage]
                    }
                    className="login-btn"
                    style={{
                      opacity:
                        !isPrivateEmailAlreadyExists &&
                        !isPrivatePasswordMismatch &&
                        privateUserName.trim() !== "" &&
                        privateUserLastName.trim() !== "" &&
                        privateEmailId.trim() !== "" &&
                        isPrivateEmailIdValid &&
                        isPasswordValid
                          ? 1
                          : 0.6
                    }}
                    onClick={this.handlePrivateSignUpClick}
                  />
                  {this.termsAndConditons("private")}

                  {isPrivateEmailAlreadyExists && (
                    <div className="success-msg">
                      <FcCancel className="sign-icon" />
                      <br></br>
                      {
                        TranslationFile.loginEmailAlreadyExistText[
                          userSelectedLanguage
                        ]
                      }
                      <center>
                        <Button
                          label={
                            TranslationFile.loginTrySignInText[
                              userSelectedLanguage
                            ]
                          }
                          className="forgot-btn"
                          onClick={(e) => {
                            this.setState({
                              activeIndex: 0,
                              privateUserName: "",
                              privateEmailId: "",
                              privatePassword: "",
                              privateConfirmPassword: "",
                              isPrivateEmailAlreadyExists: false
                            });
                          }}
                        />
                      </center>
                    </div>
                  )}
                </div>
              ) : (
                <div className="login-acc-form">
                  <p className="loginSignUpMandatoryStar">*</p>
                  <InputMask
                    mask="999999-9999"
                    className="login-singUp-registration"
                    value={accountingCompanyRegNo}
                    onChange={(e) => {
                      this.accountingCompanyRegNoOnChange(e);
                    }}
                    onBlur={() => this.accountingCompanyRegNoOnBlur()}
                    useGrouping={false}
                    placeholder={
                      TranslationFile.loginOrganizationNo[userSelectedLanguage]
                    }
                    name="rblAccRegNo"
                    autocomplete="new-password"
                  />
                  <br></br>
                  <p className="loginSignUpMandatoryStar">*</p>
                  <InputText
                    value={accountingCompanyName}
                    onChange={(e) => {
                      this.accountingCompanyNameOnChange(e);
                    }}
                    placeholder={
                      TranslationFile.dashboardCompanyName[userSelectedLanguage]
                    }
                    className="inputtext"
                    name="rblAccCompanyName"
                    autocomplete="new-password"
                  />
                  <br></br>
                  <p className="loginWhiteStar">*</p>
                  <InputText
                    value={accountingCompanyAddress}
                    onChange={(e) => {
                      this.accountingCompanyAddressOnChange(e);
                    }}
                    placeholder={
                      TranslationFile.loginAddress[userSelectedLanguage]
                    }
                    className="inputtext"
                    name="rblAccCompanyAddress"
                    autocomplete="new-password"
                  />
                  <br></br>
                  <p className="loginWhiteStar">*</p>
                  <div className="companySignUpPostalCodeCity">
                    <InputText
                      value={accountingCompanyPostalCode}
                      useGrouping={false}
                      onChange={(e) => {
                        this.accountingCompanyPostalCodeOnChange(e);
                      }}
                      placeholder={
                        TranslationFile.IncomestateCompanyPostalcode[
                          userSelectedLanguage
                        ]
                      }
                      className="inputtext"
                      name="rblAccCompanyPostalCode"
                      autocomplete="new-password"
                    />
                    <InputText
                      value={accountingCompanyCity}
                      onChange={(e) => {
                        this.accountingCompanyCityOnChange(e);
                      }}
                      placeholder={
                        TranslationFile.IncomestateCompanyCity[
                          userSelectedLanguage
                        ]
                      }
                      className="inputtext"
                      name="rblAccCompanyCity"
                      autocomplete="new-password"
                    />
                  </div>

                  <p className="loginSignUpMandatoryStar">*</p>
                  <InputText
                    value={accountingCompanyUserName}
                    onChange={(e) => {
                      this.accountingCompanyUserNameOnChange(e, "name");
                    }}
                    placeholder={
                      TranslationFile.LoginFirstName[userSelectedLanguage]
                    }
                    className="inputtext"
                    name="rblAccCompanyFName"
                    autocomplete="new-password"
                  />
                  <br></br>
                  <p className="loginSignUpMandatoryStar">*</p>
                  <InputText
                    value={accountingCompanyUserLastName}
                    onChange={(e) => {
                      this.accountingCompanyUserNameOnChange(e, "lastName");
                    }}
                    placeholder={
                      TranslationFile.LoginLastName[userSelectedLanguage]
                    }
                    className="inputtext"
                    name="rblAccCompanyLName"
                    autocomplete="new-password"
                  />
                  <br></br>

                  <p className="loginSignUpMandatoryStar">*</p>
                  <InputText
                    value={accountingCompanyEmailId}
                    onChange={(e) => {
                      this.accountingCompanyEmailIdOnChange(e);
                    }}
                    onBlur={() => this.accountingCompanyEmailIdOnBlur()}
                    placeholder={
                      TranslationFile.loginEmailText[userSelectedLanguage]
                    }
                    className="inputtext"
                    name="rblAccEmailId"
                    autocomplete="new-password"
                  />

                  {!isAccountingCompanyEmailIdValid ? (
                    <div className="error">
                      {
                        TranslationFile.loginValidEmailText[
                          userSelectedLanguage
                        ]
                      }
                    </div>
                  ) : isAccountingCompanyEmailAlreadyExists ? (
                    <div className="error">
                      {
                        TranslationFile.loginEmailAlreadyRegText[
                          userSelectedLanguage
                        ]
                      }
                    </div>
                  ) : (
                    <br></br>
                  )}

                  <p className="loginSignUpMandatoryStar">*</p>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      width: "100%"
                    }}
                  >
                    <div className="p-inputgroup" style={{ cursor: "pointer" }}>
                      <input
                        id="accountingSignupPassword"
                        ref={this.accountingPasswordInputRef}
                        type={isMaskedSignUp ? "password" : "text"}
                        value={accountingCompanyPassword}
                        onChange={(e) => {
                          this.accountingCompanyPasswordOnChange(
                            e.target.value
                          );
                        }}
                        onFocus={() => {
                          const password = this.state.accountingCompanyPassword;

                          const validation = {
                            minLength: password.length >= 6,
                            uppercase: /[A-Z]/.test(password),
                            number: /[0-9]/.test(password),
                            specialChar:
                              /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/.test(
                                password
                              )
                          };

                          this.setState({
                            passwordValidation: validation,
                            showPasswordTooltip: !(
                              validation.minLength &&
                              validation.uppercase &&
                              validation.number &&
                              validation.specialChar
                            )
                          });
                        }}
                        onBlur={() => {
                          this.accountingCompanyPasswordOnBlur();
                          this.setState({
                            showPasswordTooltip: false
                          });
                        }}
                        placeholder={
                          TranslationFile.IncomestateYearPassword[
                            userSelectedLanguage
                          ]
                        }
                        className="p-inputtext p-component"
                        autocomplete="new-password"
                      />

                      <span
                        className="p-inputgroup-addon"
                        onClick={() => this.toggleMask("signUp", 1)}
                        style={{ cursor: "pointer" }}
                      >
                        <i
                          className={
                            isMaskedSignUp ? "pi pi-eye-slash" : "pi pi-eye"
                          }
                          style={{ fontSize: "1.2rem" }}
                        ></i>
                      </span>
                    </div>
                  </div>

                  <Tooltip
                    anchorSelect="#accountingSignupPassword"
                    isOpen={this.state.showPasswordTooltip}
                    place="left"
                    positionStrategy="fixed"
                    offset={10}
                    openEvents={{}}
                    closeEvents={{}}
                    globalCloseEvents={{}}
                    clickable
                    className="password-tooltip"
                    style={{
                      zIndex: 9999,
                      backgroundColor: "#ffb3ff",
                      color: "#ff0000",
                      borderRadius: "8px",
                      padding: "10px"
                    }}
                  >
                    <>
                      <b className="passwordReqTooltipHeader">
                        {
                          TranslationFile.passwordRequirements[
                            userSelectedLanguage
                          ]
                        }
                      </b>
                    </>
                    <hr className="passwordReqTooltipHeaderHrTag"></hr>
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        gap: "5px",
                        fontWeight: "500"
                      }}
                    >
                      <div
                        style={{
                          color: passwordValidation.minLength ? "green" : "red"
                        }}
                      >
                        {passwordValidation.minLength ? "✓" : "✗"}{" "}
                        {
                          TranslationFile.minimum6characters[
                            userSelectedLanguage
                          ]
                        }
                      </div>

                      <div
                        style={{
                          color: passwordValidation.uppercase ? "green" : "red"
                        }}
                      >
                        {passwordValidation.uppercase ? "✓" : "✗"}{" "}
                        {
                          TranslationFile.atleast1uppercaseletter[
                            userSelectedLanguage
                          ]
                        }
                      </div>

                      <div
                        style={{
                          color: passwordValidation.number ? "green" : "red"
                        }}
                      >
                        {passwordValidation.number ? "✓" : "✗"}{" "}
                        {TranslationFile.atleast1number[userSelectedLanguage]}
                      </div>

                      <div
                        style={{
                          color: passwordValidation.specialChar
                            ? "green"
                            : "red"
                        }}
                      >
                        {passwordValidation.specialChar ? "✓" : "✗"}{" "}
                        {
                          TranslationFile.atleast1specialcharacter[
                            userSelectedLanguage
                          ]
                        }
                      </div>
                    </div>
                  </Tooltip>

                  <p className="loginSignUpMandatoryStar">*</p>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      width: "100%"
                    }}
                  ></div>
                  <div className="p-inputgroup">
                    <input
                      type={isMaskedSignUp1 ? "password" : "text"}
                      value={accountingCompanyConfirmPassword}
                      onChange={(e) => {
                        this.accountingCompanyConfirmPasswordOnChange(
                          e.target.value
                        );
                      }}
                      onBlur={() =>
                        this.accountingCompanyConfirmPasswordOnBlur()
                      }
                      placeholder={
                        TranslationFile.IncomestateYearConPassword[
                          userSelectedLanguage
                        ]
                      }
                      className="p-inputtext p-component"
                      autocomplete="new-password"
                      onKeyDown={(e) => {
                        if (e.key === "Enter") {
                          this.signedUpSuccessfully("accountingCompany");
                        }
                      }}
                    />

                    <span
                      className="p-inputgroup-addon"
                      onClick={() => this.toggleMask("signUp", 2)}
                      style={{ cursor: "pointer" }}
                    >
                      <i
                        className={
                          isMaskedSignUp1 ? "pi pi-eye-slash" : "pi pi-eye"
                        }
                        style={{ fontSize: "1.2rem" }}
                      ></i>
                    </span>
                  </div>

                  {isAccountingCompanyPasswordMismatch &&
                    accountingCompanyPassword != "" &&
                    accountingCompanyConfirmPassword != "" &&
                    isAccountingCompanyConfirmPasswordBlur && (
                      <div className="error">
                        {
                          TranslationFile.PasswordMustMatchText[
                            userSelectedLanguage
                          ]
                        }
                      </div>
                    )}

                  <div className="signup-json-integration-checkbox-div">
                    <Checkbox
                      onChange={(e) =>
                        this.setState({
                          jsonIntegrationCheckbox: e.checked
                        })
                      }
                      checked={jsonIntegrationCheckbox}
                    ></Checkbox>
                    <label className="signup-json-integration-label">
                      {`{JSON Integration}`}
                    </label>
                  </div>
                  <Button
                    label={
                      TranslationFile.loginSignUpText[userSelectedLanguage]
                    }
                    className="login-btn"
                    style={{
                      opacity:
                        !isAccountingCompanyEmailAlreadyExists &&
                        !isAccountingCompanyPasswordMismatch &&
                        isAccountingCompanyEmailIdValid &&
                        isPasswordValid &&
                        accountingCompanyRegNo.trim() != "" &&
                        accountingCompanyName.trim() != "" &&
                        accountingCompanyUserName.trim() != "" &&
                        accountingCompanyUserLastName.trim() !== "" &&
                        accountingCompanyEmailId.trim() != "" &&
                        accountingCompanyAddress.trim() != "" &&
                        accountingCompanyPostalCode.trim() != "" &&
                        accountingCompanyCity.trim() != "" &&
                        accountingCompanyPassword.trim() != "" &&
                        !isAccountingCompanyRegNoAlreadyExists
                          ? 1
                          : 0.6
                    }}
                    onClick={this.handleAccountingSignUpClick}
                  />

                  {this.termsAndConditons("accounting company")}

                  {isAccountingCompanyRegNoAlreadyExists && (
                    <div ref={this.errorRef} className="success-msg">
                      <FcCancel className="sign-icon" />
                      <br></br>
                      {
                        TranslationFile.loginRegExistAlready[
                          userSelectedLanguage
                        ]
                      }
                      <center>
                        <Button
                          label={
                            TranslationFile.loginTrySignInText[
                              userSelectedLanguage
                            ]
                          }
                          className="forgot-btn"
                          onClick={(e) => {
                            this.setState({
                              activeIndex: 0
                            });
                            this.resetAccountingCompanyRelatedStates();
                            this.resetPrivateRelatedStates();
                          }}
                        />
                      </center>
                    </div>
                  )}
                </div>
              )}
            </TabPanel>
          </TabView>
        </Sidebar>

        <Dialog
          blockScroll={true}
          visible={forgotPasswordDialogVisible}
          onHide={() => this.setState({ forgotPasswordDialogVisible: false })}
          header={TranslationFile.resetPassText[userSelectedLanguage]}
          className="resetYourPassword_Box"
        >
          <div>
            <div>
              <div>
                <div>
                  <center>
                    {TranslationFile.loginResetYourPass[userSelectedLanguage]}
                  </center>
                  <br></br>
                  <center>
                    <InputText
                      value={email != "" ? email : resetEmail}
                      onChange={(e) => {
                        this.resetEmailOnChange(e);
                      }}
                      placeholder={
                        TranslationFile.loginEmailText[userSelectedLanguage]
                      }
                      className="forgot-password-inputtext"
                      id="ResetYourPasswordEmailTextBar"
                      autocomplete="new-password"
                    />
                  </center>
                </div>
                <center>
                  <div>
                    <Button
                      onClick={(e) => this.sendPasswordResetLink(e)}
                      className="resetPassword-year-btn-save"
                      disabled={email == "" && resetEmail == "" && true}
                    >
                      {resetPasswordBtnLoading ? (
                        <i
                          className="pi pi-spin pi-spinner"
                          style={{ fontSize: "2rem", marginLeft: "40%" }}
                        ></i>
                      ) : (
                        <div style={{ marginLeft: "16%" }}>
                          {
                            TranslationFile.loginEmailSendText[
                              userSelectedLanguage
                            ]
                          }
                        </div>
                      )}
                    </Button>
                  </div>
                  {emailDoesNotExists && (
                    <div className="success-msg">
                      <FcCancel className="sign-icon" />
                      <br></br>
                      <p style={{ fontSize: "18px" }}>
                        {TranslationFile.loginEmailDoesnt[userSelectedLanguage]}
                      </p>
                      <center>
                        <Button
                          style={{ width: "60%" }}
                          label={
                            TranslationFile.loginTrySignUp[userSelectedLanguage]
                          }
                          className="forgot-btn"
                          onClick={(e) => {
                            this.setState({
                              activeIndex: 1,
                              email: "",
                              password: "",
                              confirmPassword: "",
                              emailNotExists: false,
                              isActiveEmailId: true,
                              forgotPasswordDialogVisible: false
                            });
                          }}
                        />
                      </center>
                    </div>
                  )}
                </center>
              </div>
            </div>
          </div>
        </Dialog>

        <Dialog
          header={TranslationFile.SuccessText[userSelectedLanguage]}
          visible={signupCheckEmailDialogBox}
          onHide={() => {
            this.setState({ signupCheckEmailDialogBox: false });
          }}
          closable={false}
        >
          <p className="m-0">
            <i
              className="fa fa-solid fa-envelope"
              style={{
                fontSize: "1.2rem",
                marginRight: "9px",
                color: "#d84444"
              }}
            ></i>
            {TranslationFile.CheckEmailForVerification[userSelectedLanguage]}
          </p>
        </Dialog>
      </div>
    );
  }
}

export default connect(mapStateToProps, null)(LoginNew);
